// NOTE: Web Crypto spelling of the digest the backend stores and compares
// against — `CONTENT_HASH_ALGORITHM` / `CONTENT_HASH_DIGEST_ENCODING` in
// server/src/vstr-audio/vstr-audio.constant.ts are "sha256" / "hex", and
// knowledge-file and probes hash the same way. A client-computed hash is only
// useful if it is byte-for-byte the string the server would have derived
// itself, so this spelling and the hex encoding in `computeBlobContentHash`
// are not free choices.
export const CONTENT_HASH_ALGORITHM = "SHA-256";

// NOTE: NSAI-6953 — the shape both clients' digests come back in: lowercase
// sha256 hex, 32 bytes as 64 characters (`computeBlobContentHash` on web,
// `computeFileContentHash` in mobile/src/utils). `toChecksumSha256Base64`
// re-encodes only a string of exactly this shape, so a malformed digest is
// dropped rather than declared.
export const CONTENT_HASH_HEX_PATTERN = /^[\da-f]{64}$/;
